export interface IEnterprises {
    id?: number
    uuid?: string
    project_id?: number
    projects?:
        [{id?: number, code?: string, description?: string, name?: string, uuid?: string}]
    responsible?: {
        id?: number
        username?: string
        uuid?: string
    }
    entrepreneur_id?: number

    entrepreneur?: {
        id?: number
        name?: string
        uuid?: string
    }

    enterprise_type_id?: number
    measurement_unit_id?: number
    enterprise_type?: {
        id?: number
        name?: string
        uuid?: string
    }
    name: string

    implantation_date?: string
    regulatory_name: string
    description: string
    size?: number
    occuped_area_size?: number
    latitude?: number
    longitude?: number
    geom_point?: string | null
    geom_polygon?: string | null
    geom_line?: string | null
    type_coordinates?: string
    city?: string
    uf?: string
    type_geometry?: string | null
    field_id?: []
    fields?: [
        {
            id?: number
        }
    ]
    activity_log?: [
        {
            properties?: {
                attributes?: {
                    entrepreneur_id: number
                    responsible_id: number
                }
            }
        }
    ]
}

export const enterprisesInitValues: IEnterprises = {
    //id: 0,
    name: '',
    regulatory_name: '',
    description: '',
}
